import * as React from "react";

import { Skeleton, SkeletonGenerator, Margins } from "@ui/Atoms";
import { Row, Column, Container } from "@ui/Atoms/Grid";

const PageSkeleton = React.memo(() => (
  <Margins xs={["base_x2", "base_x2", null, null]}>
    <Container>
      <Row>
        <Column lg={8}>
          <Skeleton shape="row" />
          <SkeletonGenerator
            count={4}
            shape="rectVertical"
            randomHeight={180}
          />
        </Column>
        <Column lg={4}>
          <Skeleton shape="rectVertical" />
          <Skeleton shape="rectVertical" />
        </Column>
      </Row>
    </Container>
  </Margins>
));
PageSkeleton.displayName = "BookingPageSkeleton";

export { PageSkeleton };
